module.exports = __webpack_public_path__ + "static/media/addRed.ab1e5878.svg";